module.exports = __webpack_public_path__ + "static/media/12UNCTAD15.975e15e2.jpg";